//import {ProductModel} from '../features/product-model';
import {log} from 'mochawesome/src/utils';

if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];
      currentVariant = null;

      constructor() {
        super();

        this.quantityInput = this.querySelector('[data-quantity-input]');
        this.productImages = this.querySelector('product-images-swiper');
        this.variantImageScroll = this.getAttribute('data-variant-image-scroll') === 'true';
        this.productFormWrapper = this.querySelector('[data-form-wrapper]');
        this.productForm = this.querySelector('product-form');
        this.siblingLinks = this.querySelectorAll('[data-swap-url]');
        this.isProductCard = this.hasAttribute('data-product-card');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        // Record recently viewed products on initial load
        try {
          const handle = this.dataset.productHandle;
          if (window.Shopify?.Products?.recordRecentlyViewed) {
            if (handle) {
              window.Shopify.Products.recordRecentlyViewed({handle});
            } else {
              window.Shopify.Products.recordRecentlyViewed();
            }
          }
        } catch (e) {
          // Silently handle recently viewed recording errors - not critical for user experience
          console.warn('Recently viewed recording error:', e);
        }

        this.onVariantChangeUnsubscriber = subscribe(theme.PUB_SUB_EVENTS.optionValueSelectionChange, this.handleOptionValueChange.bind(this));

        this.initQuantityHandlers();
        this.initProductNotificationHandlers();
        this.dispatchEvent(new CustomEvent('theme:product-info:loaded', {bubbles: true}));

        this.variantOptionImages = this.querySelectorAll('[data-variant-option-image]');
        if (this.variantOptionImages.length > 1) {
          this.optionImagesWidth();
        }

        this.updatePreorderState();

        this.checkLiveCartInfo();
        this.checkLiveCartInfoCallback = () => this.checkLiveCartInfo();
        document.addEventListener('theme:cart-drawer:close', this.checkLiveCartInfoCallback);

        this.siblingChange();
        this.subscriptionChange();
        this.subscriptionStateCheck();
        this.okendoStarWidgetCheck();

        document.addEventListener('DOMContentLoaded', () => {
          const stayBlock = this.querySelector('purchase-options[id*="stayai-subscription-widget"]');

          if (!stayBlock) return;
          if (!stayBlock.textContent.trim() && stayBlock.children.length === 0) {
            const textBlock = stayBlock.previousElementSibling;
            if (textBlock?.classList.contains('product__text')) {
              textBlock.style.display = 'none';
            }
          }

          let isUpdating = false;
          const observer = new MutationObserver(() => {
            if (isUpdating) return;

            isUpdating = true;
            this.stayAiWidgetPrices();
            setTimeout(() => {
              isUpdating = false;
            }, 0);
          });

          observer.observe(stayBlock, {
            childList: true,
            subtree: true,
            characterData: true,
          });

          this.stayAiWidgetPrices();
        });
      }

      okendoStarWidgetCheck() {
        new MutationObserver((_, obs) => {
          const container = document.querySelector('.product__content [data-oke-container]');
          if (!container) return;
          obs.disconnect();

          const applyOffset = () => {
            const width = container.getBoundingClientRect().width;
            document.querySelector('.custom__one-variant__title')?.style.setProperty('--left-offset', `${width + 10}px`);
          };

          const runAfterSettled = () => {
            // wait two frames so layout/paint has caught up
            requestAnimationFrame(() => requestAnimationFrame(applyOffset));
          };

          if (document.readyState === 'complete') {
            runAfterSettled();
          } else {
            window.addEventListener('load', runAfterSettled, {once: true});
          }
        }).observe(document.body, {childList: true, subtree: true});
      }

      stayAiWidgetPrices() {
        const pricesData = this.querySelector('[data-member-prices]');
        const stayBlock = this.querySelector('purchase-options[id*="stayai-subscription-widget"]');

        if (!pricesData || !stayBlock) return;

        function calculateSubscriptionDisplayPrice(priceInCents, discountPercent) {
          const originalPrice = Number(priceInCents) || 0;
          const discountAmount = Math.floor(originalPrice * (discountPercent / 100));
          const discountedPrice = originalPrice - discountAmount;
          return Math.max(0, discountedPrice);
        }

        const parsedPricesData = JSON.parse(pricesData.getAttribute('data-member-prices'));
        const widgetOTPPrice = this.querySelector('[data-stayai-onetime-price]');
        const widgetSubsPrice = this.querySelector('[data-stayai-subscription-price]');
        const widgetTextElem = this.querySelector('[data-stayai-subscription] .subscription-label');

        const subscriptionDiscountPercent = theme.membership.isMember ? theme.membership.memberSubscriptionDiscount : theme.membership.nonMemberSubscriptionDiscount;

        const newPrice = theme.membership.isMember ? parsedPricesData.memberPrice : parsedPricesData.nonMemberPrice;
        const calculateSubsPrice = calculateSubscriptionDisplayPrice(newPrice, subscriptionDiscountPercent);
        const widgetText = theme.membership.stayAiWidgetText.replace('[percentage]', `${subscriptionDiscountPercent}%`);

        widgetOTPPrice.innerHTML = window.theme.formatMoney(newPrice);
        widgetSubsPrice.innerHTML = window.theme.formatMoney(calculateSubsPrice);
        if (widgetTextElem) widgetTextElem.innerHTML = widgetText;
      }

      subscriptionChange() {
        const subscriptionInputs = this.querySelectorAll('[data-stayai-subscription] input');

        if (!subscriptionInputs.length) return;

        subscriptionInputs.forEach((input) => {
          input.addEventListener('change', () => {
            setTimeout(() => {
              this.stayAiWidgetPrices();

              const oneTimePrice = this.querySelector('[data-stayai-onetime-price]');
              const subscriptionPrice = this.querySelector('[data-stayai-subscription-price]');
              if (!oneTimePrice || !subscriptionPrice) return;
              subscriptionPrice.querySelector('s')?.remove();
              oneTimePrice.querySelector('s')?.remove();

              const nextHtml = input.id === 'purchaseTypeOneTime' ? oneTimePrice.innerHTML : subscriptionPrice.innerHTML;

              document.querySelectorAll('.product__page .price__regular .price-item--regular, .product__page .price-item--sale').forEach((item) => {
                if (item.innerHTML !== nextHtml) item.innerHTML = nextHtml;
              });

              document.querySelectorAll('.cart-bar .price-item--regular').forEach((item) => {
                if (item.innerHTML !== nextHtml) item.innerHTML = nextHtml;
              });
            });
          });
        });
      }

      subscriptionStateCheck() {
        const stayaiInputDisplayNone = this.querySelector('.stayai-purchase-label input');
        if (!stayaiInputDisplayNone) return;
        const stayaiSplitButton = getComputedStyle(this.querySelectorAll('.stayai-purchase-label__wrapper')[1]).borderTopWidth;
        const stayaiSideBySide = this.querySelector('.stayai-widget');

        if (getComputedStyle(stayaiSideBySide).flexDirection === 'row') {
          document.querySelector('.stayai-subscription').classList.add('stayai-widget__side-by-side');
        } else if (getComputedStyle(stayaiInputDisplayNone).display === 'none') {
          document.querySelector('.stayai-widget').classList.add('stayai-widget__input-hidden');
        } else if (stayaiSplitButton === '0px') {
          document.querySelector('.stayai-widget').classList.add('stayai-widget__split-buttons');
        }
      }

      subscriptionCheck() {
        const checked = this.querySelector('[data-stayai-subscription] input:checked');

        this.stayAiWidgetPrices();

        if (checked && checked.getAttribute('id') === 'purchaseTypeSubscription') {
          const subscriptionPrice = this.querySelector('[data-stayai-subscription-price]');
          if (!subscriptionPrice) return;
          subscriptionPrice.querySelector('s')?.remove();
          this.querySelectorAll('.product__page .price__regular .price-item--regular').forEach((item) => (item.innerHTML = subscriptionPrice.innerHTML));
          this.querySelectorAll('.cart-bar .price-item--regular').forEach((item) => (item.innerHTML = subscriptionPrice.innerHTML));
        }
      }

      siblingChange() {
        if (this.siblingLinks.length) {
          this.siblingLinks.forEach((link) => {
            link.addEventListener('click', (event) => {
              event.preventDefault();
              const productUrl = event.currentTarget?.getAttribute('data-swap-url');
              const targetId = event.currentTarget?.id;
              const shouldSwapProduct = this.dataset.url !== productUrl;
              const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

              if (!shouldSwapProduct) return;

              this.renderProductInfo({
                requestUrl: productUrl,
                targetId: targetId,
                callback: shouldSwapProduct ? this.handleSwapProduct(productUrl, shouldFetchFullPage) : this.handleUpdateProductInfo(productUrl),
              });
            });
          });
        }
      }

      checkLiveCartInfo() {
        const variantIdInput = this.productForm?.variantIdInput;
        const variantId = variantIdInput ? variantIdInput.value : null;

        if (!variantId) return;

        // Get quantity directly from the quantity input
        const quantity = this.quantityInput ? parseInt(this.quantityInput.value, 10) : 1;
        const productUrl = `${theme.routes.root}products/${this.dataset.productHandle}?section_id=api-live-cart-info&variant=${variantId}`;

        fetch(productUrl)
          .then((response) => response.text())
          .then((data) => {
            const markup = new DOMParser().parseFromString(data, 'text/html');

            const itemCountForVariant = Number(markup.querySelector('[data-item-count-for-variant]').innerHTML);
            const maxInventory = markup.querySelector('[data-max-inventory]').innerHTML;

            const maxInventoryCount = Number(maxInventory);
            const addingMoreThanAvailable = Boolean(quantity + itemCountForVariant > maxInventoryCount);

            const maxInventoryReached = maxInventory !== '' ? addingMoreThanAvailable : false;
            const errorMessagePosition = maxInventory !== '' && itemCountForVariant === maxInventoryCount ? 'form' : 'cart';

            const form = this.querySelector('[data-product-form]');
            if (!form) return;

            form.setAttribute('data-max-inventory-reached', maxInventoryReached);
            form.setAttribute('data-error-message-position', errorMessagePosition);
          })
          .catch((error) => {
            console.warn('Failed to check live cart info:', error);
            // Could show a subtle error message to user if needed
          });
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundaries();

        this.quantityEvents();

        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(theme.PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      quantityEvents() {
        if (!this.quantityInput) return;

        // Update button price when quantity changes
        this.quantityInput.addEventListener('change', () => this.updateButtonPrice());
        this.quantityInput.addEventListener('change', () => this.checkLiveCartInfo());
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
        document.removeEventListener('theme:cart-drawer:close', this.checkLiveCartInfoCallback);
      }

      initializeProductSwapUtility() {
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          //window?.ProductModel?.loadShopifyXR();
          // Call optionImagesWidth after variant change HTML updates
          this.optionImagesWidth(newNode);
        });
      }

      optionImagesWidth(container = this) {
        const variantOptionImages = container.querySelectorAll('[data-variant-option-image]');

        if (variantOptionImages.length > 1) {
          let maxItemWidth = 0;

          requestAnimationFrame(() => {
            variantOptionImages.forEach((item) => {
              const itemWidth = item.clientWidth;
              if (itemWidth > maxItemWidth) {
                maxItemWidth = itemWidth;
              }
            });

            // Only apply styling to buttons that contain variant option images
            variantOptionImages.forEach((image) => {
              const button = image.closest('[data-variant-buttons]');
              if (button) {
                button.style?.setProperty('--option-image-width', maxItemWidth + 'px');
              }
            });
          });
        }
      }

      handleOptionValueChange({data: {event, target, selectedOptionValues}}) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct ? this.handleSwapProduct(productUrl, shouldFetchFullPage) : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(document.querySelector('main'), html.querySelector('main'), this.preProcessHtmlCallbacks, this.postProcessHtmlCallbacks);
          } else {
            HTMLUpdateUtility.viewTransition(this, html.querySelector('product-info'), this.preProcessHtmlCallbacks, this.postProcessHtmlCallbacks);
          }

          // Ensure optionImagesWidth is called after the swap
          requestAnimationFrame(() => this.optionImagesWidth());
        };
      }

      renderProductInfo({requestUrl, targetId, callback}) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, {signal: this.abortController.signal})
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            if (targetId) document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];
        const sectionId = this.isProductCard ? 'api-product-card' : this.sectionId;

        // Remove all search params if this is a product card
        if (this.isProductCard) {
          const newUrl = new URL(url, window.location.origin);
          newUrl.search = '';
          url = newUrl.toString();
        }

        !shouldFetchFullPage && params.push(`section_id=${sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      showSoldoutNotificationButton(isSoldOut) {
        if (this.isProductCard) {
          if (isSoldOut) {
            this.productFormWrapper.classList.add('card-variant--soldout');
          } else {
            this.productFormWrapper.classList.remove('card-variant--soldout');
          }
        }
        if (!this.productFormWrapper.classList.contains('show-product-notification')) return;

        if (isSoldOut) {
          this.productFormWrapper.classList.add('variant--soldout');
        } else {
          this.productFormWrapper.classList.remove('variant--soldout');
        }
      }

      updatePreorderState(container = this) {
        this.submitButton = container.querySelector(`[id^=ProductSubmitButton]`);
        this.isPreorder = this.submitButton?.dataset.preorder === 'true';
        this.preorderInput = this.querySelector('[data-product-preorder]');

        if (this.preorderInput) {
          this.preorderInput.disabled = !this.isPreorder;
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          // Remove error message on variant change
          this.productForm?.querySelector('[data-cart-errors-container]').classList.remove('is-visible');

          if (!variant) {
            this.setUnavailable();

            return;
          }

          this.updatePreorderState(html);
          // const isSoldOut = !this.submitButton || this.submitButton.hasAttribute('disabled');
          const isSoldOut = !variant.available;

          if (this.isPreorder && !isSoldOut) {
            this.productForm?.toggleSubmitButton(false, window.theme.strings.preOrder);
            this.showSoldoutNotificationButton(false);
          } else if (isSoldOut) {
            this.productForm?.toggleSubmitButton(true, window.theme.strings.soldOut);
            this.showSoldoutNotificationButton(true);
          } else {
            this.productForm?.toggleSubmitButton(false, window.theme.strings.addToCart);
            this.showSoldoutNotificationButton(false);
          }

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.querySelector(`[id^=${id}-]`);

            const destination = this.querySelector(`[id^=${id}-]`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));

              if (id === 'Product-Gallery') {
                const mainSwiper = this.querySelector('product-images-swiper swiper-container')?.swiper;
                const activeSlide = mainSwiper && Array.from(mainSwiper.slides).find((s) => s.classList.contains('is-active'));
                const index = activeSlide ? Array.from(mainSwiper.slides).indexOf(activeSlide) : -1;
                if (index > 0) requestAnimationFrame(() => mainSwiper.slideTo(index, 0));
              }

              const content = document.querySelector('.product__content');
              const price = content?.querySelector('.price');
              const isDiscountMeta = price?.classList.contains('price--discount-meta') ?? false;

              content?.classList.toggle('product__content-discount-meta', isDiscountMeta);

              const subscriptionInput = this.querySelector('product-form [name="selling_plan"]');
              const oneTimePurchase = this.querySelector('#purchaseTypeOneTime');
              const purchaseLabels = this.querySelectorAll('.stayai-purchase-label');

              if (oneTimePurchase) oneTimePurchase.checked = true;
              if (subscriptionInput) subscriptionInput.disabled = isDiscountMeta;

              if (!isDiscountMeta) {
                purchaseLabels.forEach((item, i) => item.classList.toggle('is-selected', i === 0));
              }
            }
          };

          updateSourceFromDestination('Price');
          updateSourceFromDestination('Price-Btn');
          updateSourceFromDestination('Sku', ({classList}) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({classList}) => classList.contains('hidden'));
          updateSourceFromDestination('CartBar');
          updateSourceFromDestination('Preorder');
          updateSourceFromDestination('Badges');
          updateSourceFromDestination('Quantity-Form');
          updateSourceFromDestination('Notification-Form');
          updateSourceFromDestination('Accordion-Metafields');
          updateSourceFromDestination('Product-Tiles');
          updateSourceFromDestination('Accordion-Description');
          updateSourceFromDestination('Variant-Selects');
          updateSourceFromDestination('Badge-Wrapper');
          if (this.querySelector('.product__page')?.getAttribute('data-init-galery-refresh') === 'true') {
            updateSourceFromDestination('Product-Gallery');
          }

          if (this.isProductCard) {
            const productCard = this.closest('product-card');
            if (productCard) productCard.updateProductCardInfo(html);
          }

          // Reassign quantityInput after DOM updates
          this.quantityInput = this.querySelector('[data-quantity-input]');

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.sectionId}`)?.classList.remove('hidden');

          // Recalculate button price after DOM updates
          this.updateButtonPrice();

          // Update variant option image widths after DOM updates
          this.optionImagesWidth();

          // Update quantity handlers after DOM updates
          this.checkLiveCartInfo();
          this.quantityEvents();
          setTimeout(() => {
            this.subscriptionCheck();
          }, 0);
          this.updateMedia(variant?.featured_media?.id);

          publish(theme.PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        const formSelectors = [
          `#ProductForm-${this.dataset.sectionId}`, // Product form
          `#ProductFormInstallment-${this.dataset.sectionId}`, // Shop Pay Installments
          `[id^="ProductFormModal-${this.dataset.sectionId}"]`, // product-modal form
        ];

        if (this.isProductCard) {
          const input = this.closest('product-card')?.querySelector('input[name="id"]');
          if (input) {
            input.value = variantId ?? '';
            input.dispatchEvent(new Event('change', {bubbles: true}));
          }
        } else {
          this.querySelectorAll(formSelectors.join(', ')).forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            if (input) {
              input.value = variantId ?? '';
              input.dispatchEvent(new Event('change', {bubbles: true}));
            }
          });
        }
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(`${window.theme.routes.shop_url}${url}${variantId ? `?variant=${variantId}` : ''}`);

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.theme.strings.unavailable);
        this.showSoldoutNotificationButton(false);

        const selectorsArr = ['Price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules', 'Price-Btn'];

        if (this.isProductCard) {
          const selectors = selectorsArr.map((id) => `[id^=${id}-]`).join(', ');
          this.querySelectorAll(selectors).forEach(({classList}) => classList.add('hidden'));
        } else {
          const selectors = selectorsArr.map((id) => `#${id}-${this.dataset.sectionId}`).join(', ');
          document.querySelectorAll(selectors).forEach(({classList}) => classList.add('hidden'));
        }
      }

      updateMedia(variantFeaturedMediaId) {
        const gallerySliders = document.querySelectorAll('product-images-swiper swiper-container');
        if (!gallerySliders) return;
        gallerySliders.forEach((slider) => {
          slider.classList.add('is-initialized');
        });

        if (!variantFeaturedMediaId || !this.productImages) return;

        const selectedImage = this.querySelector(`[data-image-id="${variantFeaturedMediaId}"]`);
        if (!selectedImage) return;

        const selectedImageId = selectedImage.getAttribute('data-media-id');
        const isDesktopView = !theme.isMobile;

        // Update image using Swiper component
        if (this.productImages?.selectMedia) {
          this.productImages?.selectMedia(selectedImageId);
        } else {
          // Fallback: dispatch event if method not available yet
          this.productImages.dispatchEvent(
            new CustomEvent('theme:media:select', {
              bubbles: true,
              detail: {
                id: selectedImageId,
              },
            })
          );
        }

        requestAnimationFrame(() => {
          if (isDesktopView && !this.productImages.hasAttribute('data-thumbs-enabled') && this.variantImageScroll) {
            const selectedImageTop = selectedImage.getBoundingClientRect().top;

            document.dispatchEvent(
              new CustomEvent('theme:tooltip:close', {
                bubbles: false,
                detail: {
                  hideTransition: false,
                },
              })
            );

            // Scroll to image on desktop when not using thumbnails layout
            window.theme.scrollTo(selectedImageTop);
          }
        });
      }

      setQuantityBoundaries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        this.quantityInput
          .closest('quantity-input')
          ?.querySelector('popout-select')
          ?.dispatchEvent(
            new CustomEvent('theme:popout:update', {
              detail: {
                value: min,
              },
              bubbles: true,
            })
          );

        publish(theme.PUB_SUB_EVENTS.quantityUpdate, undefined);
        // Ensure button price reflects current quantity boundaries
        this.updateButtonPrice();
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        const sectionId = this.isProductCard ? 'api-product-card' : this.dataset.sectionId;
        return fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${sectionId}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.sectionId, html);
          })
          .catch((e) => {
            console.warn('Failed to fetch quantity rules:', e);
          });
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundaries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['[data-quantity-input]', '[data-quantity-rules]', '[data-quantity-label]'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '[data-quantity-input]') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
        // Update price after rules replacement
        this.updateButtonPrice();
      }

      updateButtonPrice() {
        const priceContainer = this.querySelector('[data-product-price]');

        if (!priceContainer) return;

        const variant = this.getSelectedVariant(this) || null;
        if (!variant) return;

        const quantity = this.quantityInput ? parseInt(this.quantityInput.value || '1', 10) || 1 : 1;
        const price = variant.price || 0;
        const compareAt = variant.compare_at_price || 0;

        const total = price * quantity;
        const totalCompare = compareAt > price ? compareAt * quantity : 0;

        const formattedPrice = total === 0 ? window.theme.strings.free : window.theme.formatMoney(total, theme.moneyFormat);
        let html = formattedPrice;
        if (totalCompare) {
          const formattedCompare = window.theme.formatMoney(totalCompare, theme.moneyFormat);
          html = `${formattedPrice} <s>${formattedCompare}</s>`;
        }

        priceContainer.innerHTML = html;
      }

      initProductNotificationHandlers() {
        const productNotification = this.querySelector('product-notification');
        if (!productNotification) return;

        this.querySelectorAll('[data-notification-popup-button]')?.forEach((button) => {
          button.addEventListener('click', (event) => {
            event.preventDefault();

            productNotification.dispatchEvent(
              new CustomEvent('theme:popup:open', {
                bubbles: true,
              })
            );
          });
        });
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.sectionId}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(SectionId.parseId(this.sectionId), 'related-products');
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(SectionId.parseId(this.sectionId), 'quick_order_list');
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.sectionId;
      }
    }
  );
}

// if (!customElements.get('product-model')) {
//   customElements.define('product-model', ProductModel);
// }
